
import * as React from 'react';
import autobind from 'autobind-decorator';
import SVG from 'react-inlinesvg';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { Button } from '__common/components/Button';
import { bingMapRelocation, zoomInBingMap, zoomOutBingMap } from '__editor/bingMapsRoofsSelector/components/bingMapsRoofsSelectorMap/bingMapsRoofsSelectorMap';
import { googleMapRelocation, zoomInGoogleMap, zoomOutGoogleMap } from '__editor/googleMapsRoofsSelector/components/map/map';
import { isBingMap, isGoogleMap } from '__common/constants/map';

type ZoomingButtonsState = {
  advanceRoofSelectorEnabled: boolean,
  mapType: string,
  relocated: boolean,
};
export default class ZoomingButtons extends React.Component<ZoomingButtonsState, {}> {

  @autobind
  zoomIn() {
    const { mapType, advanceRoofSelectorEnabled } = this.props;

    if (advanceRoofSelectorEnabled) {
      return;
    }

    if (mapType === 'google') {
      zoomInGoogleMap();
    }

    if (mapType === 'bing') {
      zoomInBingMap();
    }
  }

  @autobind
  zoomOut() {
    const { mapType, advanceRoofSelectorEnabled } = this.props;

    if (advanceRoofSelectorEnabled) {
      return;
    }

    if (mapType === 'google') {
      zoomOutGoogleMap();
    }

    if (mapType === 'bing') {
      zoomOutBingMap();
    }
  }

  @autobind
  relocation() {
  const { mapType, advanceRoofSelectorEnabled } = this.props;

    if (advanceRoofSelectorEnabled) {
      return;
    }

    if (isGoogleMap(mapType)) {
      googleMapRelocation();
    }
    if (isBingMap(mapType)) {
      bingMapRelocation();
    }
  }


  render() {
    const { relocated } = this.props
    return (
      <div className="zooming-tools buttons-containers map-zoom-controls">
        {relocated && (
          <Button tooltipLabel="Roof location" tooltipPosition="left" variant="text" onClick={this.relocation} className="roofs-selector-button roofs-selector-relocate">
            <SVG src={require('assets/media/icons/relocation_icon.svg')} />
          </Button>
        )}
        <Button aria-label="Zoom in" tooltipLabel="Zoom in" tooltipPosition="left" variant="text" onClick={this.zoomIn} className="roofs-selector-button roofs-selector-zoom-in">
          <ZoomInIcon className="zoom-control-icon" />
        </Button>
        <Button aria-label="Zoom out" tooltipLabel="Zoom out" tooltipPosition="left" variant="text" onClick={this.zoomOut} className="roofs-selector-button roofs-selector-zoom-out">
          <ZoomOutIcon className="zoom-control-icon" />
        </Button>
      </div>
    );
  }
}
